import { BrowserRouter as Router, Routes, Route } from "react-router";
import { Context } from "./models/context";
import { JSX, useState } from "react";

// Edit this line to trigger a redeploy

import { User } from "./models/user";

import Nav from "./components/nav/Nav";
import Login from "./pages/login/Login";
import Home from "./pages/home/Home";
import CreateUser from "./pages/createUser/CreateUser";
import Upload from "./pages/upload/Upload";
import Announcement from "./pages/announcement/Announcement";
import Stats from "./pages/stats/main-stats/Stats";
import "./app.css";
import { BaseScopes } from "./models/scopes";
import PermissionGuard from "./components/permissionGuard/PermissionGuard";
import CombinedProjects from "./pages/projects/CombinedProjects";
import AppLinks from "./pages/appLinks/AppLinks";
import AboutGrowthSpurt from "./pages/about/AboutGrowthSpurt";
import { AlertProvider } from "./contexts/AlertContext";
import { AlertContainer } from "./components/alert/AlertContainer";
import StatsGroup from "./pages/stats/StatsGroup";
import StatsUsers from "./pages/stats/StatsUsers";
import StatsApps from "./pages/stats/StatsApps";
import StatsProjects from "./pages/stats/StatsProjects";
import DataFinder from "./pages/data-finder/DataFinder";
import Search from "./pages/data-finder/search/Search";
import CampaignPage from "./pages/campaign/Campaign";

interface Page {
    name: string;
    path: string;
    element: JSX.Element;
    nav: boolean;
    scopes?: BaseScopes[];

}
const PAGES: Page[] = [
    { name: "Home", path: "/", element: <Home />, nav: false },
    { name: "Upload", path: "/upload", scopes: [BaseScopes.MAINTAIN], element: <Upload />, nav: true },
    { name: "Campaigns", path: "/campaigns", scopes: [BaseScopes.MAINTAIN], element: <CampaignPage />, nav: true },
    { name: "Announcements", path: "/announcement", scopes: [BaseScopes.ANNOUNCE], element: <Announcement />, nav: true },
    { name: "Login", path: "/login", element: <Login />, nav: false },
    { name: "Create User", path: "/create-user", element: <CreateUser />, nav: false },
    { name: "Projects", path: "/combined", element: <CombinedProjects />, nav: true},
    { name: "Stats", path: "/stats", element: <Stats />, nav: true},
    { name: "App Links", path: "/appLinks", element: <AppLinks />, nav: false},
    { name: "About GrowthSpurt", path: "/about", element: <AboutGrowthSpurt />, nav: false},
    { name: "Groups", path: "/stats/stats-groups", element: <StatsGroup />, nav: false},
    { name: "Users", path: "/stats/stats-users", element: <StatsUsers />, nav: false},
    { name: "Apps", path: "/stats/stats-apps", element: <StatsApps />, nav: false},
    { name: "Stats Projects", path: "/stats/stats-projects", element: <StatsProjects />, nav: false},
    { name: "DataFinder", path: "/data-finder", element: <DataFinder />, nav: true},
    { name: "Search", path: "/data-finder/search", element: <Search />, nav: false}
];

export function App() {
    const [user, setUser] = useState<User | null>(null);

    const navPages = PAGES.filter(p => p.nav).map(p => ({ name: p.name, path: p.path, scopes: p.scopes }));
    const noPermissions: JSX.Element = (
        <div className="error" id="no-permissions">
            <h2>You do not have permission to view this page.</h2>
            <p>Please contact your administrator if you believe this is an error.</p>
        </div>
    )

    return <>
        <AlertProvider>
            <Context.Provider value={{
                user: user,
                setUser: (u) => setUser(u)
            }}>
                    <Router>
                        <header>
                            <Nav pages={navPages} />
                        </header>
                        <main id="main">
                            <Routes>
                                {PAGES.map((page) => (
                                    <Route 
                                        path={page.path} 
                                        element={
                                            <AlertContainer>
                                                <PermissionGuard requiredScopes={page.scopes} alt={noPermissions}>
                                                    {page.element}
                                                </PermissionGuard>
                                            </AlertContainer>
                                        } 
                                        key={page.path} 
                                    />
                                ))}
                            </Routes>
                        </main>
                    </Router>
            </Context.Provider>
        </AlertProvider>
    </>;
}
